export default __webpack_public_path__ + "static/media/Mask of the Death Master.27111f98.jpg";